const state = {
    display_dashboard: 'dashboard',
}

export default state